import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import InstructorExamCard from './InstructorExamCard';
import SplitButton from '../Common/SplitButton';

const CourseDashboard = observer(class CourseDashboard extends React.Component {
  constructor() {
    super();
    this.openApprovalsDrawer = this.openApprovalsDrawer.bind(this);
    this.openEventsDrawer = this.openEventsDrawer.bind(this);
    this.renderCreateExam = this.renderCreateExam.bind(this);
    this.renderImportExam = this.renderImportExam.bind(this);
    this.renderNewExam = this.renderNewExam.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      fundingRuleSid: null,
      examSid: null
    }

    // Get instructor as proctor sessions
    this.getInstructorAppointments(this.props.courseSid);

    // Get course exams
    this.getExams(this.props.courseSid);

    // Make sure we have a list of proctor types
    SessionStore.getProctorTypes();
  }

  getInstructorAppointments(courseSid) {
    this.props.store.CourseStore.getInstructorAppointments(courseSid);
  }

  getExams(courseSid) {
    this.props.store.CourseStore.getOrderedExams(courseSid);
  }

  openApprovalsDrawer(e, examSid) {
    e.preventDefault();

    this.setState({
      examSid
    });

    const _this = this;

    setTimeout(function(){
      toggleDrawer(null, _this, 'ApproveProctor');
    });
  }

  openEventsDrawer(e, examSid) {
    toggleDrawer(e, this, 'IncidentReport');
    let { pathname } = this.props.routing.location;
    pathname += `?eventsFor=${examSid}`;
    this.props.routing.push(pathname);
  }

  getInstructorAsProctor(instructorAsProctor, instructorProctorSid) {
    let selectedIAP = null;

    instructorAsProctor.forEach(setting => {
      if(setting.sid === instructorProctorSid) {
        selectedIAP = setting;
      }
    });

    return selectedIAP;
  }

  unlockExam = (examSid, configurationSid) => {
    const data = {
      approved: true,
      locked: false
    }

    let callback = () => this.getExams();

    this.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
  }

  lockExam = (examSid, configurationSid) => {
    const data = {
      approved: true,
      locked: true
    }

    let callback = () => this.getExams();

    this.props.store.ExamStore.updateConfigurationStatus(examSid, configurationSid, data, callback);
  }

  renderResults() {
    const { translation } = this.props;
    const { CourseStore, SessionStore } = this.props.store;
    const { orderedExams } = CourseStore;
    const { active, upcoming, closed } = orderedExams;
    const examStatuses = ['active', 'upcoming', 'closed'];

    if(!SessionStore.loading) {
      return (
        <div>
          {/* If instructor has in-person appointments, render a callout */}
          {CourseStore.instructorAppointments && CourseStore.instructorAppointments.length > 0 &&
            <aside className="card">
              <icons.iconCalendar />

              <div className="card__content">
                <h3 className="card__heading">
                  {CourseStore.instructorAppointments.length === 1 &&
                    translation.appointments_singular
                  }

                  {CourseStore.instructorAppointments.length > 1 &&
                    translation.appointments_plural.replace('%count%', CourseStore.instructorAppointments.length)
                  }
                </h3>
                
                <Link className="card__btn" to="/instructor-appointments">
                  {translation.view_appointments}
                </Link>
              </div>
            </aside>
          }

          {/* Render active, upcoming, and closed exams by looping through arrays */}
          {examStatuses.map(status => {
            if (orderedExams[status] && orderedExams[status].length > 0) {
              return (
                <section
                  className="page__section exam-section"
                  key={status}
                >
                  <h2 className="exam-section__heading">
                    {translation.exam_sections[status]}
                  </h2>

                  <ol className="exam-section__list">
                    {orderedExams[status].map((exam) =>
                      <li key={exam.sid}>
                        <InstructorExamCard
                          {...this.props}
                          exam={exam}
                          onLockExam={this.lockExam}
                          onOpenApprovals={this.openApprovalsDrawer}
                          onOpenEvents={this.openEventsDrawer}
                          onUnlockExam={this.unlockExam}
                        />
                      </li>
                    )}
                  </ol>
                </section>
              )
            }

            return null;
          })}

          {
            (!orderedExams ||
            (active.length === 0 && upcoming.length === 0 && closed.length === 0)) &&

            <span className="no-results">{translation.no_results}</span>
          }
        </div>
      )
    }

    return null;
  }

  renderCreateExam() {
    return (
      <FeatureFlag
        flagKey="import-exam"
        renderFeatureCallback={this.renderImportExam}
        renderDefaultCallback={this.renderNewExam}
      />
    )
  }

  renderImportExam() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;

    let examOptions = null;
    let defaultAction = 'exams/type';

    if(SettingsStore.settings.enableWrittenExams) {
      examOptions = [
        {
          title: translation.online_exam,
          to: 'exams/type'
        }, {
          title: translation.written_exam,
          to: 'exams/add?type=written'
        }
      ]

      if(SettingsStore.settings.defaultNewExamType.toLowerCase() === 'written') {
        defaultAction = 'exams/add?type=written';
      }
    }

    return (
      <SplitButton
        iamAction="sp:CreateExam"
        iamResource={[
          `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`,
          `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam`
        ]}
        className="btn--outline"
        to={defaultAction}
        icon={<icons.iconPlus />}
        text={translation.new_exam_button}
        {...this.props}
        options={examOptions}
      />
    )
  }

  renderNewExam() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;

    let examOptions = null;
    let defaultAction = 'exams/add';

    if(SettingsStore.settings.enableWrittenExams) {
      examOptions = [
        {
          title: translation.online_exam,
          to: 'exams/add'
        }, {
          title: translation.written_exam,
          to: 'exams/add?type=written'
        }
      ]

      if(SettingsStore.settings.defaultNewExamType.toLowerCase() === 'written') {
        defaultAction = 'exams/add?type=written';
      }
    }

    return (
      <SplitButton
        iamAction="sp:CreateExam"
        iamResource={[
          `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:course/${SessionStore.userData.courseSid}`,
          `ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:exam`
        ]}
        className="btn--outline"
        to={defaultAction}
        icon={<icons.iconPlus />}
        text={translation.new_exam_button}
        {...this.props}
        options={examOptions}
      />
    )
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    return(
      <main
        className="page"
        id="main-content"
        tabIndex="0"
      >
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <SessionStore.validater>
              <div className="page__actions actions">
                <Link
                  iamAction="sp:DescribeFundingRule" iamResource={`ssrn:ss:sp:us-east:${SessionStore.userData.installSid}:funding`}
                  className="btn--outline"
                  to={`?fundingRuleScope=courseSid&scopeSid=${SessionStore.courseData.sid}`}
                  onClick={() => {toggleDrawer(null, this, 'FundingRules')}}
                >
                  {translation.funding_rules}
                </Link>

                <FeatureFlag
                  flagKey="create-exam"
                  renderFeatureCallback={this.renderCreateExam}
                />
              </div>
            </SessionStore.validater>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          fundingRuleSid={this.state.fundingRuleSid}
          examSid={this.state.examSid}
          preserveDrawer={true}
          {...this.props}
        />
      </main>
    );
  }
})

export default translate('CourseDashboard')(CourseDashboard);



// WEBPACK FOOTER //
// ./src/app/components/CourseDashboard/CourseDashboard.js